module.exports = __webpack_public_path__ + "img/java.3f99dc89.svg";